import { BaseModel, attr, belongsTo } from "../../lib/itn-ui-kit/data";

export default class ProviderEmailModel extends BaseModel {
  static urlPath = "provider_email";

  @attr("string") provider;
  @belongsTo("client") createdBy;
  @belongsTo("client") updatedBy;
  @attr("datetime") createdAt;
  @attr("datetime") updatedAt;
  @attr("number") emailType;
  @attr("string") email;
}
